import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { connect } from "react-redux";
import * as actions from "redux/actions/noteActions";
import { Translate, I18n } from "react-redux-i18n";

const FormDialog = (props) => {

    const [dialogState, setDialogState] = useState({
        values: {
            title: "",
            id: props.user_id,
        },
        isValid: false,
    });

    const [open, setOpen] = React.useState(false);

    useEffect(() => {

        setDialogState(dialogState => ({
            ...dialogState,
            isValid: dialogState.values.title.length === 0
        }));
    }, [dialogState.values]);



    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = event => {
        event.persist();
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                [event.target.name]: event.target.value
            },
        }));
    }

    const handleSave = (event) => {
        // event.preventDefault();
        if (dialogState.values.title === "") {
            return;
        }
        props.newItem(dialogState.values, props.token);
        setOpen(false);
    };

    return (
        <div>
            <button  className='btn btn-primary' onClick={handleClickOpen}>
                <Translate value="new" />
            </button>
            <div open={open} onClose={handleClose}>
                <div> Title Note</div>
                <div>
                    <div>
                        Enter Title Note
                    </div>
                    <input
                        autoFocus
                        margin="dense"
                        id="title"
                        name="title"
                        required
                        label="Title"
                        type="text"
                        onChange={handleChange}
                        fullWidth
                        value={dialogState.values.title}
                        variant="standard"
                    />

                </div>
                <div>
                    <button onClick={handleClose}
                        variant="outlined"><Translate value="cancel" /></button>
                    <button onClick={handleSave}
                        disabled={dialogState.isValid}
                        variant="outlined"
                    >
                        <Translate value="save" />
                    </button>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
    };
}
const mapDispatchToProps = dispatch => ({
    newItem: (params, token) =>
        dispatch(actions.newItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);